// extracted by mini-css-extract-plugin
export default {"link":"OwnPointsLink_link__l-6e+"};